<template>
    <div>
        <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-7">
                <h4>
                    <span
                        @click="hasHistory() ? $router.go(-1) : $router.push('/')"
                        class="button-come-back mr-2"><i class="fas fa-angle-left"></i>
                    </span> Мотивация сотрудников
                </h4>
            </div>
            <div class="col-sm-12 col-md-5 text-right" v-if="isAdministrator">
                <b-form-select 
                    v-model="selectedDepartment" 
                    size="sm" 
                    style="max-width: 250px" 
                    :options="departmentOptions"
                    @change="onDepartmentChange"
                ></b-form-select>
            </div>
        </div>

        <!-- Отдел логистики -->
        <div v-if="selectedDepartment === 'logistics'" class="logistics-motivation">
            <!-- Руководство отдела - видит всех сотрудников -->
            <div v-if="isLogisticsDepartmentHead" class="department-overview mb-4">
                <LogisticsDepartmentOverview 
                    :period="selectedPeriod"
                />
            </div>

            <!-- Персональная статистика для сотрудников -->
            <div v-else class="personal-statistics mb-4">
                <LogisticsPersonalStats 
                    :user-id="currentUser.id" 
                    :period="selectedPeriod"
                />
            </div>
        </div>

        <!-- Отдел продаж -->
        <div v-else-if="selectedDepartment === 'sales'" class="sales-motivation">
            <div v-if="isSalesDepartmentHead" class="department-overview mb-4">
                <SalesDepartmentOverview 
                    :period="selectedPeriod"
                    :department-id="salesDepartmentId"
                />
            </div>
            <div v-else-if="isSalesEmployee" class="personal-statistics mb-4">
                <SalesPersonalStats 
                    :user-id="currentUser.id" 
                    :period="selectedPeriod"
                    :department-id="salesDepartmentId"
                />
            </div>
        </div>

        <!-- Отдел ТО -->
        <div v-else-if="selectedDepartment === 'to'" class="to-motivation">
            <!-- Руководство отдела - видит всех сотрудников -->
            <div v-if="isTODepartmentHead" class="department-overview mb-4">
                <TODepartmentOverview 
                    :period="selectedPeriod"
                />
            </div>

            <!-- Персональная статистика для сотрудников ТО -->
            <div v-else-if="isTOEmployee" class="personal-statistics mb-4">
                <TOPersonalStats 
                    :user-id="currentUser.id" 
                    :period="selectedPeriod"
                />
            </div>

            <!-- Для других пользователей -->
            <div v-else class="other-users">
                <div class="card">
                    <div class="card-body text-center">
                        <i class="fas fa-tools fa-3x mb-3 text-muted"></i>
                        <h5>Доступ к мотивации ТО</h5>
                        <p class="text-muted">У вас нет доступа к системе мотивации отдела ТО</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Заглушка для других отделов -->
        <div v-else class="other-departments">
            <div class="card">
                <div class="card-body text-center">
                    <i class="fas fa-tools fa-3x mb-3 text-muted"></i>
                    <h5>Мотивация сотрудников</h5>
                    <p class="text-muted">Система мотивации находится в разработке.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LogisticsDepartmentOverview from '@/components/motivation2025/LogisticsDepartmentOverview.vue'
import LogisticsPersonalStats from '@/components/motivation2025/LogisticsPersonalStats.vue'
import TODepartmentOverview from '@/components/motivation2025/TODepartmentOverview.vue'
import TOPersonalStats from '@/components/motivation2025/TOPersonalStats.vue'
import SalesDepartmentOverview from '@/components/motivation2025/SalesDepartmentOverview.vue'
import SalesPersonalStats from '@/components/motivation2025/SalesPersonalStats.vue'

export default {
    name: 'Motivation2025',
    components: {
        LogisticsDepartmentOverview,
        LogisticsPersonalStats,
        TODepartmentOverview,
        TOPersonalStats,
        SalesDepartmentOverview,
        SalesPersonalStats
    },
    data() {
        return {
            selectedDepartment: '',
            selectedPeriod: '',
            departmentOptions: [
                { value: 'logistics', text: 'Отдел логистики' },
                { value: 'sales', text: 'Отдел продаж' },
                { value: 'to', text: 'Отдел ТО' },
                // { value: 'other', text: 'Другие отделы' }
            ],
            periodOptions: [],
        }
    },
    computed: {
        ...mapGetters("auth", ["currentUser"]),
        isAdministrator() {
            return this.currentUser.role && (this.currentUser.role.includes('administrator') || 
                                             this.currentUser.role.includes('president') ||
                                             this.currentUser.role.includes('accountant') ||
                                             this.currentUser.role.includes('head-accountant'))
        },
        isLogisticsDepartmentHead() {
            // Проверяем, является ли пользователь руководителем отдела логистики
            return this.currentUser.role && (this.currentUser.role.includes('logistics-head-manager') || 
                                             this.currentUser.role.includes('administrator') || 
                                             this.currentUser.role.includes('president') ||
                                             this.currentUser.role.includes('accountant') ||
                                             this.currentUser.role.includes('head-accountant'))
        },
        isTODepartmentHead() {
            // Проверяем, является ли пользователь руководителем отдела ТО
            return this.currentUser.role && (this.currentUser.role.includes('TO-head-manager') || 
                                             this.currentUser.role.includes('administrator') || 
                                             this.currentUser.role.includes('president') ||
                                             this.currentUser.role.includes('accountant') ||
                                             this.currentUser.role.includes('head-accountant'))
        },
        isTOEmployee() {
            // Проверяем, является ли пользователь сотрудником отдела ТО
            return this.currentUser.role && (
                this.currentUser.role.includes('TO-manager') ||
                this.currentUser.role.includes('TO-head-manager') ||
                this.currentUser.role.includes('administrator') || 
                this.currentUser.role.includes('president') ||
                this.currentUser.role.includes('accountant') ||
                this.currentUser.role.includes('head-accountant')
            )
        },
        isTOManager() {
            // Проверяем, является ли пользователь обычным менеджером ТО (без доступа к мотивации)
            return this.currentUser.role && this.currentUser.role.includes('TO-manager') &&
                   !this.currentUser.role.includes('administrator') &&
                   !this.currentUser.role.includes('president') &&
                   !this.currentUser.role.includes('accountant') &&
                   !this.currentUser.role.includes('head-accountant')
        },
        isSalesDepartmentHead() {
            return this.currentUser.role && (
                this.currentUser.role.includes('sales-head-manager') ||
                this.currentUser.role.includes('administrator') ||
                this.currentUser.role.includes('president') ||
                this.currentUser.role.includes('accountant') ||
                this.currentUser.role.includes('head-accountant')
            )
        },
        isSalesEmployee() {
            return this.currentUser.role && (
                this.currentUser.role.includes('sales-manager') ||
                this.currentUser.role.includes('sales-head-manager') ||
                this.currentUser.role.includes('administrator') ||
                this.currentUser.role.includes('president') ||
                this.currentUser.role.includes('accountant') ||
                this.currentUser.role.includes('head-accountant')
            )
        },
        defaultDepartment() {
            // Определяем отдел по умолчанию в зависимости от роли пользователя
            if (this.isLogisticsDepartmentHead && !this.isAdministrator) {
                return 'logistics'
            } else if (this.isSalesDepartmentHead && !this.isAdministrator) {
                return 'sales'
            } else if (this.isTODepartmentHead && !this.isAdministrator) {
                return 'to'
            } else if (this.isTOEmployee && !this.isAdministrator) {
                return 'to' // Обычные сотрудники ТО видят свой отдел
            } else if (this.isTOManager) {
                return 'to' // TO-manager видят свой отдел
            } else if (this.isAdministrator) {
                return 'logistics' // По умолчанию логистика для админов
            }
            return 'logistics' // Fallback
        },
        salesDepartmentId() {
            // Если известен ID отдела продаж, можно захардкодить/вынести в настройки.
            // По умолчанию ставим 1.
            return 1
        },
        availableQuarters() {
            const now = new Date()
            const year = now.getFullYear()
            const month = now.getMonth() + 1
            
            const quarters = []
            const minYear = 2025
            const minQuarter = 4 // Q4 2025 - минимальный квартал для выбора
            
            // Перебираем годы начиная с 2025
            for (let y = minYear; y <= year; y++) {
                if (y === minYear && y === year) {
                    // Для 2025 года, когда это текущий год
                    // Q4 доступен начиная с сентября
                    if (month >= 9) {
                        quarters.push({ value: `${y}-Q4`, text: `Q4 ${y} (сентябрь, октябрь, ноябрь)` })
                    }
                    // Если мы в декабре 2025, добавляем Q1 2026
                    if (month === 12) {
                        quarters.push({ value: `${y + 1}-Q1`, text: `Q1 ${y + 1} (декабрь, январь, февраль)` })
                    }
                } else if (y === minYear) {
                    // Для 2025 года, когда это прошлый год - все кварталы
                    quarters.push({ value: `${y}-Q1`, text: `Q1 ${y} (декабрь, январь, февраль)` })
                    quarters.push({ value: `${y}-Q2`, text: `Q2 ${y} (март, апрель, май)` })
                    quarters.push({ value: `${y}-Q3`, text: `Q3 ${y} (июнь, июль, август)` })
                    quarters.push({ value: `${y}-Q4`, text: `Q4 ${y} (сентябрь, октябрь, ноябрь)` })
                } else if (y === year) {
                    // Для текущего года (после 2025) - все актуальные кварталы
                    // Q1: декабрь предыдущего года, январь и февраль текущего
                    if (month === 12 || month === 1 || month === 2) {
                        const q1Year = month === 12 ? y + 1 : y
                        quarters.push({ value: `${q1Year}-Q1`, text: `Q1 ${q1Year} (декабрь, январь, февраль)` })
                    } else if (month >= 3) {
                        quarters.push({ value: `${y}-Q1`, text: `Q1 ${y} (декабрь, январь, февраль)` })
                    }
                    if (month >= 3) quarters.push({ value: `${y}-Q2`, text: `Q2 ${y} (март, апрель, май)` })
                    if (month >= 6) quarters.push({ value: `${y}-Q3`, text: `Q3 ${y} (июнь, июль, август)` })
                    if (month >= 9) quarters.push({ value: `${y}-Q4`, text: `Q4 ${y} (сентябрь, октябрь, ноябрь)` })
                } else {
                    // Для прошлых лет (после 2025) - все кварталы
                    quarters.push({ value: `${y}-Q1`, text: `Q1 ${y} (декабрь, январь, февраль)` })
                    quarters.push({ value: `${y}-Q2`, text: `Q2 ${y} (март, апрель, май)` })
                    quarters.push({ value: `${y}-Q3`, text: `Q3 ${y} (июнь, июль, август)` })
                    quarters.push({ value: `${y}-Q4`, text: `Q4 ${y} (сентябрь, октябрь, ноябрь)` })
                }
            }
            
            // Разворачиваем массив, чтобы текущий квартал был сверху
            return quarters.reverse()
        }
    },
    mounted() {
        // Инициализация отдела по умолчанию в зависимости от роли
        this.selectedDepartment = this.defaultDepartment
        // Инициализация периода
        this.selectedPeriod = this.getCurrentQuarter()
    },
    methods: {
        onDepartmentChange() {
            // Логика смены отдела
            console.log('Selected department:', this.selectedDepartment)
        },
        onPeriodChange() {
            // Логика смены периода
            console.log('Selected period:', this.selectedPeriod)
        },
        formatCurrency: function(amount) {
            return new Intl.NumberFormat('ru-RU', {
                style: 'currency',
                currency: 'RUB',
                minimumFractionDigits: 0
            }).format(amount)
        },
        hasHistory() {
            return window.history.length > 2
        },
        getCurrentQuarter() {
            const now = new Date()
            const year = now.getFullYear()
            const month = now.getMonth() + 1
            const minYear = 2025
            const minQuarter = 4 // Q4 2025 - минимальный квартал
            
            let currentQuarter = ''
            
            // Финансовая схема кварталов (год начинается с декабря):
            // Q1: декабрь, январь, февраль (12,1,2)
            // Q2: март, апрель, май (3,4,5)
            // Q3: июнь, июль, август (6,7,8)
            // Q4: сентябрь, октябрь, ноябрь (9,10,11)
            if (month === 12 || month === 1 || month === 2) {
                currentQuarter = month === 12 ? `${year + 1}-Q1` : `${year}-Q1`
            } else if (month >= 3 && month <= 5) {
                currentQuarter = `${year}-Q2`
            } else if (month >= 6 && month <= 8) {
                currentQuarter = `${year}-Q3`
            } else if (month >= 9 && month <= 11) {
                currentQuarter = `${year}-Q4`
            }
            
            // Проверяем, что квартал не раньше Q4 2025
            const [qYear, qNum] = currentQuarter.split('-Q')
            const quarterNum = parseInt(qNum)
            
            if (qYear < minYear || (qYear == minYear && quarterNum < minQuarter)) {
                return '2025-Q4' // Возвращаем минимальный доступный квартал
            }
            
            return currentQuarter || '2025-Q4'
        }
    },
    mounted() {
        // Инициализируем отдел по умолчанию на основе роли пользователя
        this.selectedDepartment = this.defaultDepartment
        this.selectedPeriod = this.getCurrentQuarter()
    }
}
</script>

<style scoped>
.button-come-back {
    background-color: #0D6247;
    cursor: pointer;
    color: #FFF;
}

.button-come-back:hover {
    background-color: #EA7B27;
}
</style>
